// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/appointmenspage/cross_close_drawer.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drawer_cross_logo {
  width: 32px;
  height: 32px;
  cursor: pointer;
  color: #546881;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center no-repeat;
}`, "",{"version":3,"sources":["webpack://./src/shared/components/CloseCross/CloseCross.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,oEAAA;AACJ","sourcesContent":[".drawer_cross_logo {\r\n    width: 32px;\r\n    height: 32px;\r\n    cursor: pointer;\r\n    color: #546881;\r\n    background: url(\"../../../../public/appointmenspage/cross_close_drawer.svg\")\r\n        center no-repeat;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
